import { render } from "./OriReporte.vue?vue&type=template&id=66a85920&scoped=true"
import script from "./OriReporte.vue?vue&type=script&lang=js"
export * from "./OriReporte.vue?vue&type=script&lang=js"

import "../main.css?vue&type=style&index=0&lang=css&external"
import "./OriReporte.vue?vue&type=style&index=1&id=66a85920&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66a85920"]])

export default __exports__